import React from 'react'
import TimelineElement from 'redesign/components/organisms/timeline-element'
import { DEFAULT_TIMELINE_ITEMS_IDS } from 'redesign/components/templates/timeline/factory/default-timeline-factory/constants'
import type { DocumentT } from 'types'
import TimelineDocument from '../timeline-document'
import TimelinePersonalDataForm from '../timeline-personal-data-form'
import TimelineVerifyIdentity from '../timeline-verify-identity'
import type { TimelineContentProps } from './types'

const TimelineContent: React.FC<TimelineContentProps> = ({
  badgeProps,
  avatarData,
  content,
  reminder,
  isOffice,
  id,
}) => {
  const document = content?.document
  const hasDocument = Boolean(document) || id === DEFAULT_TIMELINE_ITEMS_IDS.monthly_sheet
  const showElement = !hasDocument && Boolean(content)
  const displayVerifyIdentity = Boolean(content?.identificationCard)
  const displayPersonalDataForm = Boolean(content?.formTaskUuid) || id === DEFAULT_TIMELINE_ITEMS_IDS.share_user_data

  if (displayVerifyIdentity) {
    return <TimelineVerifyIdentity tenantName={content?.tenantName} taskUuid={content?.taskUuid} />
  }

  if (displayPersonalDataForm) {
    return <TimelinePersonalDataForm tenantName={content?.tenantName} isOffice={isOffice} />
  }

  return (
    <>
      {hasDocument && <TimelineDocument document={document as DocumentT} openMonthlySheetDialog={() => {}} />}
      {showElement && (
        <TimelineElement
          {...content?.absenceDetails}
          badge={content?.badge}
          avatar={avatarData}
          badgeProps={badgeProps}
          comment={content?.text}
          title={avatarData?.userName}
          reminder={reminder}
        />
      )}
    </>
  )
}

export default TimelineContent
